"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScopedVar = void 0;
const getScopedVar = ({ name, prefix, }) => {
    return prefix ? `--${prefix}-corvid-${name}` : `--corvid-${name}`;
};
exports.getScopedVar = getScopedVar;
//# sourceMappingURL=getScopedVar.js.map